module.exports = __webpack_public_path__ + "open-sans-latin-400italic.fd2ba7503f70aafcdcc4.svg";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-400italic.svg
// module id = ../../../../typeface-open-sans/files/open-sans-latin-400italic.svg
// module chunks = 1 3